<template>
    <div id="confirmation_summary">
        <hr>
        <div class="row">
            <div class="col-12 bg-secondaryL p-3 my-auto">
                <h4>Confirmation Summary</h4>
            </div>
        </div>
        <div class="row mt-3">
            <!-- Service info start -->
            <div class="col-sm-6">
                <div class="row">
                    <div class="col-12">
                        <div class="row pb-2">
                            <div class="col-xl-4 col-lg-5 col-md-6">
                                <p class="text-left d-inline">Outgoing Customer:</p>
                            </div>
                            <div class="col-xl-8 col-lg-7 col-md-6">
                                <p class="font-weight-bold text-left d-inline">{{customer.CustomerName}}</p>
                                <p class="font-weight-bold text-left d-inline"> - {{customer.CustomerReference}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="row pb-2">

                        </div>
                    </div>
                    <div class="col-12">
                        <div class="row pb-2">
                            <div class="col-xl-4 col-lg-5 col-md-6">
                                <p class="text-left d-inline">Transfer Date:</p>
                            </div>
                            <div class="col-xl-8 col-lg-7 col-md-6">
                                <p class="font-weight-bold text-left d-inline">{{transferDate | moment('Do MMMM YYYY')}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div><!-- left row col 6 close -->
            <div class="col-sm-6">
                <div class="row">
                    <div class="col-xl-4 col-lg-5 col-md-6">
                        <p class="text-left d-inline">Destination Customer:</p>
                        <!-- Customer ref only shows if it is an existing customer -->
                    </div>
                    <div class="col-xl-8 col-lg-7 col-md-6">
                        <p class="font-weight-bold text-left d-inline">{{destinationCustomer.CustomerName}}</p>
                        <p class="font-weight-bold text-left d-inline"
                            v-if="destinationCustomer.hasOwnProperty('CustomerReference')"> -
                            {{destinationCustomer.CustomerReference}}</p>
                    </div>
                </div>
            </div><!-- right row col 6 close -->
        </div> <!-- service info row close -->

        <hr>

        <div v-for="(service, index) in transferServices" :key="index">

            <div class="row">
                <div class="col-12 mt-2">
                    <div class="row">
                        <div class="col-sm-12 ml-1">
                            <h5 class="text-left"><img
                                    :src="require(`@/assets/img/${service.Service.ServiceType.toLowerCase()}_icon.png`)"
                                    class="img-fluid pr-2 mb-1" alt="Gas icon">{{service.Service.ServiceIdentifier}} -
                                {{service.Site.Address.AddressLines[0]}}</h5>
                        </div>
                    </div>
                </div>
            </div>

            <hr>

            <div class="row mt-1" v-if="service.Service.ServiceType == 'Gas'">

                <div class="col-12">
                    <div class="row ml-1">
                        <div class="col-sm-12">
                            <h5 class="text-left pb-2">Meter Reading</h5>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="row ml-3">
                        <div class="col-sm-4">
                            <p class="font-weight-bold text-left">Reading Date: </p>
                        </div>
                        <div class="col-8 col-sm-6 w-100">
                            <p class="border brs pl-2 pb-1 pt-1">
                                <span class="ml-1"
                                    v-if="service.ReadingDate">{{service.ReadingDate | moment("DD.MM.YY")}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="row ml-3">
                        <div class="col-sm-4">
                            <p class="font-weight-bold text-left">Meter Serial: </p>
                        </div>
                        <div class="col-8 col-sm-6 w-100">
                            <p class="border brs pl-2 pb-1 pt-1">
                                {{service.CurrentMeter.Serial}}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-sm-4">
                            <p class="font-weight-bold text-left">Reading Source: </p>
                        </div>
                        <div class="col-8 col-sm-6 w-100">
                            <p class="border brs pl-2 pb-1 pt-1">
                                {{wordSplit(service.ReadingSource)}}
                            </p>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <p class="font-weight-bold text-left">Meter Reading: </p>
                        </div>
                        <div class="col-8 col-sm-6 w-100">
                            <div class="d-flex justify-content-start">
                                <input v-for="(digit, i) in service.Reading.length" :key="i"
                                    class="form-control form-control-lg font-weight-bold at_input" type="text"
                                    maxLength="1" readonly :value="service.Reading[i]">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-for="(meter, mIndex) in service.CurrentMeters" :key="mIndex">
                <div class="row mt-1"
                    v-if="service.Service.ServiceType == 'Electricity' && service.MeasurementMethod == 'NonHalfHourly'">
                    <div class="col-12">
                        <div class="row ml-1">
                            <div class="col-sm-12">
                                <h5 class="text-left pb-2">Reading Set</h5>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="row ml-3">
                            <div class="col-sm-4">
                                <p class="font-weight-bold text-left">Reading Date: </p>
                            </div>
                            <div class="col-8 col-sm-6 w-100">
                                <p class="border brs pl-2 pb-1 pt-1">
                                    <span class="ml-1"
                                        v-if="service.ReadingDate">{{service.ReadingDate | moment("DD.MM.YY")}}</span>
                                </p>
                            </div>
                        </div>

                        <div class="row ml-3">
                            <div class="col-sm-4">
                                <p class="font-weight-bold text-left">Meter Serial: </p>
                            </div>
                            <div class="col-8 col-sm-6 w-100">
                                <p class="border brs pl-2 pb-1 pt-1">
                                    {{meter.Serial}}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">

                        <div class="row">
                            <div class="col-sm-4">
                                <p class="font-weight-bold text-left">Register Reading(s): </p>
                            </div>
                            <div class="col-8 col-sm-6 w-100">
                                <div class="d-flex justify-content-start"
                                    v-for="(register, rIndex) in service.RegisterReadings" :key="rIndex">
                                    <div v-if="register.Serial == meter.Serial">
                                        <div class="d-flex justify-content-center mt-2">
                                            <i class="my-auto mr-2"
                                                :class="{ 'fas fa-sun': register.BillingTypeId == 'Day', 'fas fa-moon': register.BillingTypeId == 'Night', 'fas fa-couch': register.BillingTypeId == 'Weekend', 'fas fa-unlock-alt': register.BillingTypeId == 'Unrestricted' }"></i>
                                            <span>{{register.BillingTypeId}}</span>
                                        </div>
                                        <!-- enter readings input -->
                                        <div class="d-flex justify-content-center mt-2">
                                            <!-- Elec new -->
                                            <input v-for="(digit, i) in register.Digits" :key="i"
                                                class="form-control form-control-lg font-weight-bold at_input mr-2"
                                                required type="text" pattern="\d*" maxLength="1" readonly
                                                :value="register.Reading[i]">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-3">
                <!-- Commercials start -->
                <div class="col-12">
                    <div class="row ml-1">
                        <div class="col-sm-12">
                            <h5 class="text-left pb-2">Commercial Configuration</h5>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="row ml-3">
                        <div class="col-12">
                            <div class="row pb-2">
                                <div class="col-xl-4 col-lg-5 col-md-6">
                                    <p class="font-weight-bold text-left d-inline">Commercial:</p>
                                </div>
                                <div class="col-8 col-sm-6 w-100">
                                    <p class="border brs pl-2 pb-1 pt-1">{{service.Commercial}}%
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row pb-2">
                                <div class="col-xl-4 col-lg-5 col-md-6">
                                    <p class="font-weight-bold text-left d-inline">CCA Reduction:</p>
                                </div>
                                <div class="col-8 col-sm-6 w-100">
                                    <p class="border brs pl-2 pb-1 pt-1">{{service.CCA}}%</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-12" v-if="service.BillingAq">
                            <div class="row pb-2">
                                <div class="col-xl-4 col-lg-5 col-md-6">
                                    <p class="font-weight-bold text-left d-inline">Billing AQ:</p>
                                </div>
                                <div class="col-8 col-sm-6 w-100">
                                    <p class="border brs pl-2 pb-1 pt-1">{{service.BillingAq}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div><!-- left row col 6 close -->
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-12">
                            <div class="row pb-2">
                                <div class="col-xl-4 col-lg-5 col-md-6">
                                    <p class="font-weight-bold text-left d-inline">CCL Exemption Type:</p>
                                </div>
                                <div class="col-8 col-sm-6 w-100">
                                    <p class="border brs pl-2 pb-1 pt-1">
                                        {{wordSplit(service.ExemptionType)}}</p>
                                </div>
                            </div>

                        </div>
                        <div class="col-12">
                            <div class="row pb-2">
                                <div class="col-xl-4 col-lg-5 col-md-6">
                                    <p class="font-weight-bold text-left d-inline">CCA Description:</p>
                                </div>
                                <div class="col-8 col-sm-6 w-100">
                                    <p v-if="service.CCADescription" class="border brs pl-2 pb-1 pt-1 pr-2">
                                        {{service.CCADescription}}</p>
                                    <p v-else class="border brs pl-2 pb-3 pt-3"></p>
                                </div>
                            </div>
                        </div>
                        <div class="col-12" v-if="service.BillingAq">
                            <div class="row pb-2">
                                <div class="col-xl-4 col-lg-5 col-md-6">
                                    <p class="font-weight-bold text-left d-inline">Application Rule:</p>
                                </div>
                                <div class="col-8 col-sm-6 w-100">
                                    <p class="border brs pl-2 pb-1 pt-1">
                                        {{wordSplit(service.ApplicationRule)}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-12" v-if="service.HHNHHMappingType">
                            <div class="row pb-2">
                                <div class="col-xl-4 col-lg-5 col-md-6">
                                    <p class="font-weight-bold text-left d-inline">HH NHH Mapping:</p>
                                </div>
                                <div class="col-8 col-sm-6 w-100">
                                    <p class="border brs pl-2 pb-1 pt-1">
                                        {{mappedmap(service.HHNHHMappingType)}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div><!-- right row col 6 close -->
            </div> <!-- Commercials row close -->

            <div class="row mt-3" v-if="service.PriorityServices.length !== 0">

                <div class="col-12">
                    <div class="row ml-1">
                        <div class="col-sm-12">
                            <h5 class="text-left pb-2">Priority Services</h5>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="row ml-1">
                        <div class="col-sm-12">
                            <div class="col-11 text-left">
                                <ul class="dashed">
                                    <li class="mb-2" v-for="(priorityServices, index) in service.PriorityServices"
                                        :key="index">
                                        <span class="d-inline">{{wordSplit(priorityServices.PsrType)}}
                                            <span>({{priorityServices.EffectiveFromDate | moment('DD.MM.YYYY')}}
                                                <span v-if="priorityServices.EffectiveToDate"> -
                                                    {{priorityServices.EffectiveToDate | moment('DD.MM.YYYY')}}</span>
                                                <span v-else> - N/A</span>
                                                )</span>
                                            <span v-if="priorityServices.PsrSpecificDetails"
                                                v-b-popover.hover.topright="priorityServices.PsrSpecificDetails"
                                                title="Notes" class="pointer">
                                                <i class="fas fa-sticky-note ml-2"></i>
                                                <i class="fas fa-pencil-alt"></i>
                                            </span>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <hr>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <div class="row mt-3">
                    <div class="col-sm-6">
                        <div class="row ml-1">
                            <div class="col-sm-12">
                                <h5 class="text-left pb-2">Service Bundle</h5>
                                <p class="d-inline">The services will be set up on the</p>
                                <p class="d-inline ml-1 font-weight-bold">{{serviceBundle.ServiceBundleName}}</p>
                                <p class="d-inline ml-1">bundle</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-12">
                                <h5 class="text-left pb-2">Contract End Date</h5>
                                <p class="d-inline ml-1">The contract is due to expire</p>
                                <p class="d-inline ml-1 font-weight-bold">{{contractEndDate | moment('Do MMMM YYYY')}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr>
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-md-6 offset-md-3">
                        <p class="font-weight-bold text-center mt-4">Are you sure you want to proceed?</p>
                        <div class="col-sm-12 col-md-6 d-inline">
                            <b-btn class="btn btn-hc btn-xs-block btn-sm-block float-left w-40" role="button"
                                @click="next" :disabled="submitStatus == 'PENDING'">Yes</b-btn>
                        </div>
                        <div class="col-sm-12 col-md-6 d-inline">
                            <b-btn class="btn btn-hc btn-xs-block btn-sm-block float-right w-40" role="button"
                                @click="back" :disabled="submitStatus == 'PENDING'">No</b-btn>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { _ } from 'vue-underscore';
import moment from 'moment';
import Swal from 'sweetalert2';

import { uuid } from 'vue-uuid';
import Vue from 'vue';

export default {
  data() {
    return {
      submitStatus: null,
      psrGUID: uuid.v1(),
    };
  },

  methods: {
    next() {
      // console.log(this.servicesForTransfer)
      // return
      setTimeout(() => {
        Swal('Transfer in Progress, Please Wait...');
        Swal.showLoading();
        this.submitStatus = 'PENDING';
        this.$http
          .post(
            'https://' +
              Vue.config.honeycomb.contractbot.domain +
              '/api/v1/transfers',
            {
              Id: this.createCustomer ? null : this.destinationCustomer.Id,
              OutgoingCustomerId: this.preFlightResponse.CustomerId,
              CustomerReference: this.createCustomer
                ? null
                : this.destinationCustomer.CustomerReference,
              TransferDate: this.transferDate,
              Contracts: [
                {
                  SignedDate: this.contractStartDate,
                  StartDate: this.contractStartDate,
                  EndDate: this.contractEndDate,
                  NoticePeriodDays: 30,
                  ContractType: this.contractType,
                  ServiceBundleId: this.serviceBundle.ServiceBundleId,
                  ServiceBundleName: this.serviceBundle.ServiceBundleName,
                  ServicesForTransfer: this.servicesForTransfer,
                },
              ],
              CustomerType: this.createCustomer
                ? this.destinationCustomer.CustomerType
                : null,
              CustomerName: this.createCustomer
                ? this.destinationCustomer.CustomerName
                : null,
              BillingGroups: this.createCustomer
                ? [this.destinationCustomer.BillingGroups]
                : null,
              Contacts: !this.createCustomer
                ? null
                : this.sameAsPrimary
                  ? [this.destinationCustomer.PrimaryContact]
                  : [
                      this.destinationCustomer.PrimaryContact,
                      this.destinationCustomer.BillingContact,
                    ],
              ContactRoles: this.createCustomer
                ? [
                    {
                      ContactId: this.destinationCustomer.PrimaryContact.Id,
                      RoleType: 'Primary',
                      RoleDescription: 'Primary Contact',
                    },
                    {
                      ContactId: this.sameAsPrimary
                        ? this.destinationCustomer.PrimaryContact.Id
                        : this.destinationCustomer.BillingContact.Id,
                      RoleType: 'Billing',
                      RoleDescription: 'Billing Contact',
                    },
                  ]
                : null,
              CollectionMethod: this.createCustomer
                ? this.destinationCustomer.CollectionMethod
                : null,
              RegularCollectionAmount: this.createCustomer
                ? this.destinationCustomer.RegularCollectionAmount
                : null,
              DaysOfMonth: this.createCustomer
                ? this.destinationCustomer.DaysOfMonth
                : null,
              CustomerBankDetails:
                this.createCustomer &&
                (this.destinationCustomer.CollectionMethod === 'DDVAR' ||
                  this.destinationCustomer.CollectionMethod === 'DDFIX')
                  ? [
                      {
                        BankDetailsId: uuid.v1(),
                        DdOrganisationId: this.bankDetails.DdOrganisationId,
                      },
                    ]
                  : null,
              BankSortCode: this.createCustomer
                ? this.bankDetails.SortCode
                : null,
              BankAccountNumber: this.createCustomer
                ? this.bankDetails.AccountNumber
                : null,
              BankAccountName: this.createCustomer
                ? this.bankDetails.AccountName
                : null,
              BillDeliveryMethods: this.createCustomer
                ? [this.destinationCustomer.BillDeliveryMethods]
                : null,
              PriorityServiceSets: this.createCustomer
                ? [
                    {
                      Id: this.psrGUID,
                      CustomerId: this.createCustomer
                        ? 'New'
                        : this.destinationCustomer.Id,
                      PriorityServices: this.priorityServices,
                      PsrSetType: 'Energy',
                    },
                  ]
                : null,
              CollectionDueDays: this.destinationCustomer.CollectionDueDays,
              PaymentDueDays: this.destinationCustomer.PaymentDueDays,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            this.$store.commit('updateTransferResponse', response.data);
            this.submitStatus = 'OK';
            Swal.close();
            this.$emit('next');
          })
          .catch((error) => {
            Swal.close();
            this.submitStatus = 'ERROR';
            // Error
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx

              if (error.response.data.MoreInformation.length > 0) {
                error.response.data.MoreInformation.forEach((e) => {
                  this.$snotify.error(`${e.Error}`, {
                    timeout: 0,
                    closeOnClick: true,
                  });
                });
              } else {
                this.$snotify.error(`${error.response.data.UserDescription}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              }
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              this.$snotify.error(`No response received.`, {
                timeout: 0,
                closeOnClick: true,
              });
            } else {
              // Something happened in setting up the request that triggered an Error
              this.$snotify.error(`${error.message}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          });
      });
    },
    back() {
      this.$emit('back');
    },
    readingInt(reading) {
      return parseInt(reading.toString().replace(/,/g, ''));
    },
    diff: function(readingDate) {
      return moment().diff(readingDate, 'days');
    },
    filterRegisterReadings(registerReadings, meter) {
      return _.filter(registerReadings, function(rr) {
        return rr.Serial == meter.Serial;
      });
    },
    formatRegisterReadings(registerReadings, meter) {
      var filteredRegisterReadings = this.filterRegisterReadings(
        registerReadings,
        meter
      );
      var formattedRegisterReadings = [];

      filteredRegisterReadings.forEach((rr) => {
        if (rr.Reading.length > 0) {
          var r = rr.Reading.toString();
          r = +parseFloat(r.replace(/,/g, '')).toFixed(2);

          formattedRegisterReadings.push({
            SharedId: uuid.v1(),
            Reading: r,
            MeterRegisterId: rr.MeterRegisterId,
            IsValid: rr.IsValid,
          });
        }
      });

      return formattedRegisterReadings;
    },
    formatBillingEac(billingEac) {
      var formattedBillingEac = [];

      billingEac.forEach((registerEac) => {
        formattedBillingEac.push({
          RegisterId: registerEac.RegisterId,
          BillingEac: parseInt(registerEac.BillingEac),
        });
      });

      return formattedBillingEac;
    },
    aggregateEac(billingEac) {
      var MeterPointEac = 0;
      billingEac.forEach((registerEac) => {
        MeterPointEac += parseInt(registerEac.BillingEac);
      });
      return MeterPointEac;
    },

    mappedmap(hhnhhmap) {
      let mp = this.$store.state.contracts.hhnhhmappings.find(m=> m.value === hhnhhmap)

      if (mp) return mp.label
    },
  },
  computed: {
    customer() {
      return this.$store.state.customers.customer;
    },
    destinationCustomer() {
      return this.$store.state.transfer.destinationCustomer;
    },
    bankDetails() {
      return this.$store.state.transfer.transferBankDetails;
    },
    transferDate() {
      return this.$store.state.transfer.transferDate;
    },
    serviceDetails() {
      return this.$store.state.transfer.serviceDetails;
    },
    transferServices() {
      return this.$store.state.transfer.transferServices;
    },
    serviceBundle() {
      return this.$store.state.transfer.serviceBundle;
    },
    contractStartDate() {
      return this.$store.state.transfer.contractStartDate;
    },
    contractTerm() {
      return parseInt(this.$store.state.transfer.contractTerm);
    },
    contractType() {
      return this.$store.state.transfer.contractType;
    },
    contractEndDate() {
      return moment(this.contractStartDate).add(this.contractTerm, 'years');
    },
    createCustomer() {
      return this.$store.state.transfer.createCustomer;
    },
    existingCustomer() {
      return this.$store.state.transfer.existingCustomer;
    },
    sameAsPrimary() {
      return this.$store.state.transfer.sameAsPrimary;
    },
    preFlightResponse() {
      return this.$store.state.transfer.preFlightResponse;
    },
    priorityServices() {
      var set = [];
      this.transferServices.forEach((serviceDetail) => {
        serviceDetail.PriorityServices.forEach((priorityService) => {
          set.push(priorityService);
        });
      });
      return set;
    },
    servicesForTransfer() {
      var services = [];

      this.transferServices.forEach((ts) => {
        const PreviousTenancySharedId = ts.Contract.Services.map((s) => ({
          ...s,
          d: s[`${s.ServiceType}Details`],
        })).find((s) => (s.ServiceIdentifier = ts.Service.ServiceIdentifier)).d
          .TenancySharedId;

        const TenancyId = ts.Tenancies.find(
          (t) => t.TenancySharedId === PreviousTenancySharedId
        ).Id;

        var serviceForTransfer = {
          TenancyId,
          ServiceIdentifier: ts.Service.ServiceIdentifier,
          ServiceType: ts.Service.ServiceType,
          SiteId: ts.Site.Id,
          EffectiveFrom: this.transferDate,
          EffectiveTo: null,
          PriorityServiceSetId: this.psrGUID,
        };
        if (ts.Service.ServiceType == 'Gas') {
          serviceForTransfer.GasTransferDetails = {
            ReadingSharedId: uuid.v1(),
            Mprn: +ts.Service.ServiceIdentifier,
            Serial: ts.CurrentMeter.Serial,
            ReadingDate: ts.ReadingDate,
            MeterReading: this.readingInt(ts.Reading),
            OverrideTolerances: true,
            ReadingSource: ts.ReadingSource,
            ReadingReason: 'Other',
            CommercialConfigurations: [
              {
                EffectiveFrom: this.transferDate,
                EffectiveTo: null,
                CommercialPercentage: ts.Commercial,
                CclExemptionType: ts.ExemptionType,
                CcaAgreementDescription: ts.CCADescription,
                CcaReductionPercentage: ts.CCA,
                BillingAq: ts.BillingAq,
                ApplicationRule: ts.BillingAq ? ts.ApplicationRule : null,
              },
            ],
          };
        }
        if (ts.Service.ServiceType == 'Electricity') {
          var readingSets = [];
          ts.CurrentMeters.forEach((meter) => {
            readingSets.push({
              ReadingSetSharedId: uuid.v1(),
              Mpan: +ts.Service.ServiceIdentifier,
              Serial: meter.Serial,
              RegisterReadings: this.formatRegisterReadings(
                ts.RegisterReadings,
                meter
              ),
              ReadingDate: ts.ReadingDate,
              ReadingType: ts.ReadingType,
              OverrideTolerances: true,
            });
          });
          serviceForTransfer.ElectricityTransferDetails = {
            ReadingSets: ts.MeasurementMethod == 'NonHalfHourly' ? readingSets: undefined,
            CommercialConfigurations: [
              {
                EffectiveFrom: this.transferDate,
                EffectiveTo: null,
                CommercialPercentage: ts.Commercial,
                CclExemptionType: ts.ExemptionType,
                CcaAgreementDescription: ts.CCADescription,
                CcaReductionPercentage: ts.CCA,
                ApplicationRule: ts.BillingEac ? ts.ApplicationRule : null,
                HhNhhMappingId: ts.HHNHHMappingType,
                EacLevel: ts.EacLevel,
                BillingEac:
                  ts.EacLevel == 'Register'
                    ? this.formatBillingEac(ts.BillingEac)
                    : null,
                MeterPointBillingEac:
                  ts.EacLevel == 'MeterPoint'
                    ? parseInt(ts.MeterPointBillingEac)
                    : this.aggregateEac(ts.BillingEac),
              },
            ],
          };
        }
        services.push(serviceForTransfer);
      });
      return services;
    },
  },
};
</script>
